import { render, staticRenderFns } from "./stock_in.vue?vue&type=template&id=634caa5b&scoped=true&"
import script from "./stock_in.vue?vue&type=script&lang=js&"
export * from "./stock_in.vue?vue&type=script&lang=js&"
import style0 from "./stock_in.vue?vue&type=style&index=0&id=634caa5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634caa5b",
  null
  
)

export default component.exports